import { render } from "./ContinueRegister.vue?vue&type=template&id=5e5aebfb&scoped=true"
import script from "./ContinueRegister.vue?vue&type=script&lang=js"
export * from "./ContinueRegister.vue?vue&type=script&lang=js"

import "./ContinueRegister.vue?vue&type=style&index=0&id=5e5aebfb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5e5aebfb"

export default script